// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1oEK2","footer":"ModalError_footer__vdnsk"};